import React from "react";
import {
  GoogleMap,
  Marker,
  Circle,
  useJsApiLoader,
} from "@react-google-maps/api";

const MapComponent = ({
  apiKey,
  center = { lat: 37.7749, lng: -122.4194 },
  zoom = 14,
  markers = [],
  onMarkerDragEnd,
  containerStyle = { width: "100%", height: "400px" },
  circleRadius = 0,
}) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: apiKey,
  });

  const isValidCoordinate = (coord) => typeof coord === "number" && isFinite(coord);

  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  const mapCenter = {
    lat: isValidCoordinate(center?.lat) ? center.lat : 28.0229,
    lng: isValidCoordinate(center?.lng) ? center.lng : 73.3119,
  };

  return (
    <GoogleMap mapContainerStyle={containerStyle} center={mapCenter} zoom={zoom}>
      {markers?.filter(m => isValidCoordinate(m?.lat) && isValidCoordinate(m?.lng)).map((marker, index) => (
        <Marker
          key={index}
          position={marker}
          draggable={onMarkerDragEnd ? true : false}
          onDragEnd={(e) => {
            const newLat = e.latLng.lat();
            const newLng = e.latLng.lng();
            if (onMarkerDragEnd) {
              onMarkerDragEnd({ lat: newLat, lng: newLng });
            }
          }}
        />
      ))}
      {circleRadius > 0 && (
        <Circle
          center={center}
          radius={circleRadius}
          options={{
            fillColor: "#13fa02",
            fillOpacity: 0.2,
            strokeColor: "#FF0000",
            strokeOpacity: 0.5,
            strokeWeight: 1,
          }}
        />
      )}
    </GoogleMap>
  );
};

export default MapComponent;
